import { useSelector } from "react-redux";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  InfoBanner,
  InfoBannerSeverity,
} from "@tenant/ui";
import clsx from "clsx";
import styles from "./FixedPricingBanner.module.scss";
import { AccountSelectors } from "@/modules/account";
import { getAdditionalPointsPurchase } from "@/store/flights/shop/store";
import { TenantIconNameEnum } from "@/types/tenantIcons";

export const FixedPricingBanner = ({ className }: { className?: string }) => {
  const { t, formatFiatCurrency } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "FixedPricingBanner");

  const additionalPointsPurchase = useSelector(getAdditionalPointsPurchase);
  const rewardsAccountId = useSelector(AccountSelectors.getRewardsAccountId);
  const hasMinimumRedemptionPoints = useSelector(
    AccountSelectors.getHasMinimumRedemptionPoints
  );

  // Don't show if PointsEligibilityBanner should be displayed
  if (!hasMinimumRedemptionPoints) return null;

  if (!additionalPointsPurchase || !rewardsAccountId) return null;

  return (
    <InfoBanner
      severity={InfoBannerSeverity.INFO}
      icon={TenantIconNameEnum.pointsShoppingCart}
      className={clsx(block, className)}
    >
      <div className={cn("content-container")}>
        <Accordion type="single" collapsible className={cn("accordion")}>
          <AccordionItem
            value="additional-points-purchase-details"
            className={cn("accordion-item")}
          >
            <AccordionTrigger className={cn("accordion-trigger")}>
              <span className={cn("title")}>
                {t(
                  "core-flights.fixedPricing.additionalPointsPurchase.banner.title",
                  {
                    amount:
                      additionalPointsPurchase.fixedPoints.toLocaleString(),
                  }
                )}
              </span>
            </AccordionTrigger>
            <AccordionContent className={cn("accordion-content")}>
              <p className={cn("description")}>
                {t(
                  "core-flights.fixedPricing.additionalPointsPurchase.banner.content",
                  {
                    amount:
                      additionalPointsPurchase.purchaseAmount.toLocaleString(),
                    price: formatFiatCurrency(
                      additionalPointsPurchase.costPerBlock.fiat
                    ),
                    pointsPerBlock:
                      additionalPointsPurchase.pointsPerBlock.toLocaleString(),
                  }
                )}
              </p>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </InfoBanner>
  );
};
